'use client';
import {useLocale, useTranslations} from 'next-intl';
import Image from 'next/image';
import Link from 'next/link';
import {useEffect, useState} from 'react';
import TagManager from 'react-gtm-module';
import {target} from './helpers/utils';
import Url from './modules/Url';

export default function Footer() {
  const t = useTranslations('Footer');
  const lang = useLocale();
  const year = new Date().getFullYear().toString();
  const [showFooter, setShowFooter] = useState(false);

  const footerSites = [
    {
      image: '/img/footer/LiKaShing-Foundation.png',
      link: 'http://www.lksf.org/',
      alt: t('logo.li-ka-shing-foundation')
    },
    {
      image: '/img/footer/ckhh-logo.png',
      link: 'http://www.ckh.com.hk/en/global/home.php/',
      alt: t('logo.ckhh')
    },
    {
      image: '/img/footer/2019ASW1983-Project-Lol-Bilingual-Logo-v1.png',
      link: 'https://projectlol.aswatson.com/en/',
      alt: t('logo.project-lol')
    },
    {
      image: '/img/footer/wac-2020.png',
      link: 'https://wac.aswatson.com/',
      alt: t('logo.wac')
    },
    {
      image: '/img/footer/ssa-185th-2026.png',
      link: 'https://ssa.aswatson.com/',
      alt: t('logo.ssa')
    },
    {
      image: '/img/footer/website-silver-2024.png',
      link: 'https://www.ogcio.gov.hk/en/our_work/community/web_mobileapp_accessibility/index.html',
      alt: t('logo.web-accessibility')
    }
  ];

  useEffect(() => {
    TagManager.initialize({
      gtmId: 'GTM-T5BL7L'
    });
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        pagePath: 'page-path-here',
        pageTitle: 'page-title-here'
      }
    });
    // get GET params from URL
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('popup') !== '1') {
      setShowFooter(true);
    }
  });

  return (
    showFooter && (
      <footer className="flex flex-col mt-5 common-layout footer">
        <div className="bg-[#efefef] ">
          <div className="container flex flex-wrap justify-center items-center divide-x divide-[#dddddd]">
            {footerSites.map((s, i) => (
              <div
                className="px-1 flex justify-center items-center my-5"
                key={i}
              >
                <Link prefetch={false} href={s.link} target={target(s.link)}>
                  <Image
                    className="max-w-[200px] max-h-[80px] object-contain"
                    src={s.image}
                    alt={s.alt}
                    width={200}
                    height={80}
                    style={{width: 'auto', height: '80px'}}
                  />
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-[#e22319]">
          <div className="container text-white">
            <div className="flex justify-center items-center mt-5">
              <Image
                src={`/img/footer/asw-footer-logo-${lang}.png`}
                alt="AS Watson Group - A member of CK Hutchison Holdings"
                width={220}
                height={50}
              />
            </div>
            <div className="flex flex-row justify-center items-center mt-5 gap-1">
              <div className="flex flex-col justify-center items-center">
                <div className=" text-xs mb-4 w-[70px] text-center">
                  {/* <Link href="/" locale={lang}> */}
                  <Link prefetch={false} href={`/`}>
                    {t('home')}{' '}
                  </Link>
                </div>
              </div>
              <div className="flex flex-col justify-center items-center">
                <div className=" text-xs mb-4 w-[70px] text-center">
                  {/* <Link href="/career" locale={lang}> */}
                  <Link prefetch={false} href={`/career`} locale={lang}>
                    {t('join-us')}{' '}
                  </Link>
                </div>
              </div>
              <div className="flex flex-col justify-center items-center">
                <div className=" text-xs mb-4 w-[70px] text-center">
                  {/* <Link href="/contact" locale={lang}> */}
                  <Link prefetch={false} href={`/contact`}>
                    {t('contact-us')}{' '}
                  </Link>
                </div>
              </div>
            </div>
            <div className="flex flex-row justify-center items-center mt-1 gap-5">
              <div className="flex flex-col justify-center items-center">
                <Link
                  prefetch={false}
                  href="https://www.facebook.com/ASWGroupofficial/"
                  target="_blank"
                >
                  <Image
                    src={`/img/footer/facebook.png`}
                    alt={t('fb')}
                    width={32}
                    height={32}
                  />
                </Link>
              </div>
              <div className="flex flex-col justify-center items-center">
                <Link
                  prefetch={false}
                  href="https://www.instagram.com/aswatsongroup_corp/"
                  target="_blank"
                >
                  <Image
                    src={`/img/footer/instagram.png`}
                    alt={t('ig')}
                    width={32}
                    height={32}
                  />
                </Link>
              </div>
              <div className="flex flex-col justify-center items-center">
                <Link
                  prefetch={false}
                  href="https://www.linkedin.com/company/aswatson/"
                  target="_blank"
                >
                  <Image
                    src={`/img/footer/linkedin.png`}
                    alt={t('linkedin')}
                    width={32}
                    height={32}
                  />
                </Link>
              </div>
            </div>

            <div className="flex md:flex-wrap justify-center items-center my-5 text-xs  divide-x divide-white pt-5">
              <div className="px-2 md:px-4">
                {/* <Link href="/disclaimer" locale={lang}> */}
                <Url href={`/${lang}/home/disclaimer/`}>{t('disclaimer')}</Url>
              </div>
              <div className="px-2 md:px-4 ">
                <button className="ot-sdk-show-settings">
                  {t('cookies')}{' '}
                </button>
              </div>
              <div className="px-2 md:px-4 ">
                {/* <Link href="/accessibility-statement" locale={lang}> */}
                <Url href={`/home/accessibility-statement/`}>
                  {t('accessibility-statement')}{' '}
                </Url>
              </div>

              <div className="hidden md:flex flex-wrap justify-center items-center px-4 text-xs  ">
                <Url href={`/home/copyright`}>{t('rights', {year})}</Url>
              </div>
            </div>
            <div className="flex md:hidden flex-wrap justify-center items-center px-4 text-xs m-auto pb-5 ">
              <Url href={`/home/copyright`}>{t('rights', {year})}</Url>
            </div>
          </div>
          <div></div>
        </div>
      </footer>
    )
  );
}
